import React from 'react';
import { promisePillars } from '../mock';
import { Layers, Crosshair, ShieldCheck } from 'lucide-react';

const iconMap = { Layers, Crosshair, ShieldCheck };

const PromiseBand = () => {
  return (
    <>
      {/* Black tagline strip */}
      <section className="bg-[#0b0b0b]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 grid lg:grid-cols-2 gap-8">
          <div className="border-l-2 border-[#e30613] pl-6">
            <h2 className="text-white uppercase font-bold tracking-wide text-[15px] md:text-[17px] leading-snug">
              Nie sprzedajemy metrów membrany.<br />
              Dostarczamy spokój po deszczu.
            </h2>
          </div>
          <p className="text-white/70 text-[13px] md:text-[14px] leading-relaxed">
            Dach płaski nie wybacza przypadkowych rozwiązań. Najczęściej problem
            nie leży na środku połaci, tylko na detalach: przy attykach, wpustach,
            przejściach instalacyjnych, obróbkach i łączeniach systemów.
            Dlatego każdy dach traktujemy jako układ techniczny, a nie zwykłe pokrycie.
          </p>
        </div>
      </section>

      {/* White pillars */}
      <section className="bg-[#f3f3f1]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10 md:gap-6">
          {promisePillars.map((p, i) => {
            const Icon = iconMap[p.icon];
            return (
              <div key={p.title} className={`flex items-start gap-5 ${i > 0 ? 'md:border-l md:border-black/10 md:pl-8' : ''}`}>
                <div className="shrink-0 w-12 h-12 flex items-center justify-center text-[#1c1c1c]">
                  <Icon size={36} strokeWidth={1.4} />
                </div>
                <div>
                  <h3 className="font-bold tracking-[0.18em] text-[13px] text-[#1c1c1c]">{p.title}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-[#3a3a3a] max-w-[280px]">{p.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default PromiseBand;
